import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Button,
  Box,
  Checkbox
} from '@chakra-ui/react';
import { MailingListType } from '../Table/MaintenanceMailingListTable';
import { UpdateMailingListsApi } from '../../../../apis/UpdateMaintenance.api';
import {
  BanInputType,
  CustomStringInput
} from '../../../atoms/CustomStringInput';
import { AxiosError } from 'axios';

interface ResponseType {
  success: boolean;
  data: MailingListType[] | null;
  message: unknown | null;
}
interface props {
  isOpen: boolean;
  onClose: () => void;
  EditData: MailingListType | undefined;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<MailingListType[] | undefined>
  >;
  CreateOrUpdateStateSwitch: () => void;
}

const GetMailInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { Length: 300, BanInputType: BanInputType.None, Value: '' };
  }
  return { Length: 300, BanInputType: BanInputType.None, Value: addData };
};

const MailingListEditWindow: React.FC<props> = (props) => {
  const {
    isOpen,
    onClose,
    EditData,
    setMaintenanceDatas,
    CreateOrUpdateStateSwitch
  } = props;
  const [email, setEmail] = useState(EditData?.email);
  const [enable, setEnable] = useState(EditData?.enable);

  const PostApi = async () => {
    if (EditData !== undefined && EditData.id !== undefined) {
      const response: ResponseType = await UpdateMailingListsApi(EditData.id, {
        email: email,
        enable: enable
      });

      if (
        response.message !== null &&
        (response.message as AxiosError).status?.toString() === '400'
      ) {
        alert('不正なメールアドレスの形式です。');
        return;
      } else if (response.success === false) {
        alert('編集に失敗しました。');
        return;
      }
      setMaintenanceDatas(response.data as MailingListType[]);
      CreateOrUpdateStateSwitch();
      onClose();
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='280px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            メーリングリストを編集
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text gridColumn='1/2' mt={4}>
                メールアドレス
              </Text>
              <CustomStringInput
                CheckInfo={GetMailInputCheckData(EditData?.email?.toString())}
                inputValue={email}
                setValue={setEmail}
                PhohibitionCharaCheck={false}
              />
              <Checkbox
                gridColumn='2/2'
                mt={2}
                isChecked={enable}
                onChange={(e) => setEnable(e.target.checked)}
              >
                有効
              </Checkbox>
            </Box>
            <Button mt={10} onClick={() => PostApi()}>
              更新
            </Button>
            <Button mt={10} ml={10} onClick={() => onClose()}>
              取り消す
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default React.memo(MailingListEditWindow);
